import React, { useLayoutEffect } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import Sidebar from "./layout/Sidebar";
import Dashboard from "./pages/Dashboard/Dashboard";
import { PowerAtlas } from "./pages/Dashboard/Atlas/Atlas";
import { LoginPage } from "./pages/Login/Login";
import "./App.css";
import { MarketMontoring } from "./pages/Dashboard/MarketMonitoring/MarketMonitoring";
import { BankingAnalytics } from "./pages/Dashboard/BankingAnalytics/BankingAalytics";
import { ConsumptionAnalytics } from "./pages/Dashboard/Consumption/Consumption";
import { Protected, ProtectedPage } from "./pages/Protected";
import {
  DashboardRoutes,
  DemoRoutes,
  GridcoRoutes,
  HppcRoutes,
  RajasthanRoutes,
} from "./Routes";
import { Gnai } from "./pages/GNAi/Gnai";
import { useSelector } from "react-redux";
import { Documents } from "./pages/Documents/Documents";
import { Sidebar2 } from "./layout/Sidebar2";
import { Login2 } from "./pages/Login/Login2";
import MarketMonitoring from "./pages/MarketMonitoringCERC/MarketMonitoring";
import { ChartBuilder } from "./pages/ChartBuilder/ChartBuilder";
import { DamAnalysis } from "./pages/DamAnalysis/DamAnalysis";
import Dmrc from "./pages/Dmrc/Dmrc";
import RajDashboard from "./pages/Rajasthan/Raj_Dashboard";
import DemoRajDashboard from "./pages/DemoState/Raj_Dashboard";
import { Gridco } from "./pages/Gridco/Gridco.jsx";
import GridcoDashboard from "./pages/Gridco/Gridco_Das";
import HpgclDashboard from "./pages/Hppc/Hppc_Das";
import CommonTrader from "./pages/Trader/CommonTrader";
import DemoDashboard from "./pages/Demo/Raj_Dashboard";
import { RootState } from "./store/store";
import { MarketDerivativePage } from "./pages/market-derivative/MarketDerivativePage";

function App() {
  const active = useSelector((state: RootState) => state.menu.isActive);
  const width = useSelector((state: any) => state.FilterWidthSlice.width);
  const location = useLocation();

  const isRuvnlRoute =
    location.pathname.startsWith("/ruvnl") ||
    location.pathname.startsWith("/gridco") ||
    location.pathname.startsWith("/demo");
  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      "--gas-chart-margin",
      isRuvnlRoute ? "0" : "1rem"
    );
  }, [isRuvnlRoute]);

  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      "--page-width",
      active ? "calc(100vw - 127px)" : "calc(100vw - 60px)"
    );
  }, [active]);

  useLayoutEffect(() => {
    let FilterWidth = width;
    document.documentElement.style.setProperty("--mainPage-width", FilterWidth);
  }, [width]);

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <Protected>
              <Navigate to="/dashboard" />
            </Protected>
          }
        />
        <Route path="/login" element={<Login2 />} />

        <Route
          path="/dashboard"
          element={
            <>
              <Sidebar2 />

              <Outlet />
            </>
          }
        >
          <Route
            index={true}
            element={
              <div className="content2">
                <Dashboard />
              </div>
            }
          />

          {DashboardRoutes.map((Proute, index) => {
            return (
              <Route
                key={index}
                path={Proute.path}
                element={
                  Proute.notPrtoected ? (
                    Proute.element
                  ) : (
                    <div
                      className={
                        Proute.noDefaultPadding ? "content2" : "content"
                      }
                    >
                      <ProtectedPage
                        children={Proute.element}
                        pageId={"/" + Proute.path}
                      />
                    </div>
                  )
                }
              />
            );
          })}
        </Route>

        {/* <Route path="/trader" element={<CommonTrader />} /> */}

        {/* RUVNL Routes */}
        <Route
          path="/ruvnl"
          element={
            <>
              <Sidebar2 />
              <Outlet />
            </>
          }
        >
          <Route
            index={true}
            element={
              <div className="content2">
                <RajDashboard />
              </div>
            }
          />
          {RajasthanRoutes.map((Proute, index) => {
            return (
              <Route
                key={index}
                path={Proute.path}
                element={
                  Proute.notPrtoected ? (
                    Proute.element
                  ) : (
                    <div
                      className={
                        Proute.noDefaultPadding ? "content2" : "content"
                      }
                    >
                      <ProtectedPage
                        children={Proute.element}
                        pageId={"/" + Proute.path}
                      />
                    </div>
                  )
                }
              />
            );
          })}
        </Route>
        <Route
          path="/discom-demo"
          element={
            <>
              <Sidebar2 />
              <Outlet />
            </>
          }
        >
          <Route
            index={true}
            element={
              <div className="content2">
                <DemoDashboard />
              </div>
            }
          />
          {DemoRoutes.map((Proute, index) => {
            return (
              <Route
                key={index}
                path={Proute.path}
                element={
                  Proute.notPrtoected ? (
                    Proute.element
                  ) : (
                    <div
                      className={
                        Proute.noDefaultPadding ? "content2" : "content"
                      }
                    >
                      <ProtectedPage
                        children={Proute.element}
                        pageId={"/" + Proute.path}
                      />
                    </div>
                  )
                }
              />
            );
          })}
        </Route>

        {/* Demo routes */}

        <Route
          path="/demo"
          element={
            <>
              <Sidebar2 />
              <Outlet />
            </>
          }
        >
          <Route
            index={true}
            element={
              <div className="content2">
                <DemoRajDashboard />
              </div>
            }
          />
          {DemoRoutes.map((Proute, index) => {
            return (
              <Route
                key={index}
                path={Proute.path}
                element={
                  Proute.notPrtoected ? (
                    Proute.element
                  ) : (
                    <div
                      className={
                        Proute.noDefaultPadding ? "content2" : "content"
                      }
                    >
                      <ProtectedPage
                        children={Proute.element}
                        pageId={"/" + Proute.path}
                      />
                    </div>
                  )
                }
              />
            );
          })}
        </Route>

        {/* GRIDCO Routes */}
        <Route
          path="/gridco"
          element={
            <>
              <Sidebar2 />
              <Outlet />
            </>
          }
        >
          <Route
            index={true}
            element={
              <div className="content2">
                <GridcoDashboard />
              </div>
            }
          />
          {GridcoRoutes.map((Proute, index) => {
            return (
              <Route
                key={index}
                path={Proute.path}
                element={
                  Proute.notPrtoected ? (
                    Proute.element
                  ) : (
                    <div
                      className={
                        Proute.noDefaultPadding ? "content2" : "content"
                      }
                    >
                      <ProtectedPage
                        children={Proute.element}
                        pageId={"/" + Proute.path}
                      />
                    </div>
                  )
                }
              />
            );
          })}
        </Route>

        {/* HPGCL Routes */}
        <Route
          path="/hppc"
          element={
            <>
              <Sidebar2 />
              <Outlet />
            </>
          }
        >
          <Route
            index={true}
            element={
              <div className="content2">
                <HpgclDashboard />
              </div>
            }
          />

          {HppcRoutes.map((Proute, index) => {
            return (
              <Route
                key={index}
                path={Proute.path}
                element={
                  Proute.notPrtoected ? (
                    Proute.element
                  ) : (
                    <div
                      className={
                        Proute.noDefaultPadding ? "content2" : "content"
                      }
                    >
                      <ProtectedPage
                        children={Proute.element}
                        pageId={"/" + Proute.path}
                      />
                    </div>
                  )
                }
              />
            );
          })}
        </Route>
        <Route
          path="/gnai"
          element={
            <Protected>
              <Sidebar2 />
              <div className="content">
                <ProtectedPage children={<Gnai />} pageId="/gnai" />
              </div>
            </Protected>
          }
        />
        
        <Route
          path="/derivative"
          element={
            <Protected>
              <div className="w-full h-full">
                <MarketDerivativePage />
              </div>
            </Protected>
          }
        />
        <Route
          path="/marketMonitoring"
          element={
            <Protected>
              {/* <Sidebar2 /> */}
              <div className="">
                <ProtectedPage
                  children={<MarketMonitoring />}
                  pageId="/marketMonitoring"
                />
              </div>
            </Protected>
          }
        />
        <Route path="/chartBuilder" element={<ChartBuilder />} />
        <Route path="/damAnalysis" element={<DamAnalysis />} />
        <Route
          path="/dmrc"
          element={
            <Protected>
              <Sidebar2 />
              <div className="content2">
                <ProtectedPage children={<Dmrc />} pageId="/dmrc" />
              </div>
            </Protected>
          }
        />
        <Route
          path="/document"
          element={
            <Protected>
              <Sidebar2 />

              <div className="content2">
                <ProtectedPage pageId="/gnadoc" key={"gnadoc"}>
                  <Documents />
                </ProtectedPage>
              </div>
            </Protected>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
